import { literal, object, type InferOutput } from 'valibot'
import { Engine } from '../../../../engine/Engine.type'
import { setEngineStateFromExternal } from '../../../../engine/setEngineState'
import { StateSchema, type State } from '../../../State.type'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const SetStateActionSchema = object({
  type: literal(ActionType.Map.SetState),
  state: StateSchema,
})

export type SetStateAction = InferOutput<typeof SetStateActionSchema>

export function createSetStateAction(state: State): SetStateAction {
  return {
    type: ActionType.Map.SetState,
    state,
  }
}

export async function handleSetStateAction(
  engine: Engine,
  action: SetStateAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  console.warn('use of ActionType.Map.SetState is a code smell')
  setEngineStateFromExternal(engine, action.state)
}
